import lood from '../assets/images/oude-lood.jpg';
import blauw from '../assets/images/blauwe-kpn.jpg';
import achtpaar from '../assets/images/8paar.jpg';

export const KABELS = [
  {
    soort: 'GPEW',
    image: blauw,
    type: '1 X 4 GPEW',
    omschrijving: 'dit is kabel 1',
    kabel: [
      {
        naam: '1a',
        kleur: 'Rood',
        key: 1,
      },
      {
        naam: '1b',
        kleur: 'Blauw',
        key: 2,
      },
      {
        '2a': 'Oranje',
        naam: '2a',
        kleur: 'Oranje',
        key: 3,
      },
      {
        naam: '2b',
        kleur: 'Wit',
        key: 4,
      },
    ],
    key: 1,
  },
  {
    soort: 'GPLK',
    image: lood,
    type: '1 X 4 GPLK',
    omschrijving: 'dit is kabel 2',
    kabel: [
      {
        naam: '1a',
        kleur: 'Rood - Wit',
        key: 5,
      },
      {
        naam: '1b',
        kleur: 'Blauw - Wit',
        key: 6,
      },
      {
        naam: '2a',
        kleur: 'Oranje',
        key: 7,
      },
      {
        naam: '2b',
        kleur: 'Wit',
        key: 8,
      },
    ],
    key: 2,
  },
  {
    soort: 'GPLK',
    image: achtpaar,
    type: '4 X 2 GPLK',
    omschrijving: 'dit is kabel 3',
    kabel: [
      {
        naam: '1a',
        kleur: 'Wit (Rood)',
        key: 9,
      },
      {
        naam: '1b',
        kleur: 'Rood',
        key: 10,
      },
      {
        naam: '2a',
        kleur: 'Wit (Blauw)',
        key: 11,
      },
      {
        naam: '2b',
        kleur: 'Blauw',
        key: 12,
      },
      {
        naam: '3a',
        kleur: 'Wit (Oranje)',
        key: 13,
      },
      {
        naam: '3b',
        kleur: 'Oranje',
        key: 14,
      },
      {
        naam: '4a',
        kleur: 'Wit (Groen)',
        key: 15,
      },
      {
        naam: '4b',
        kleur: 'Groen',
        key: 16,
      },
    ],
    key: 3,
  },
];

